import { render } from "./App.vue?vue&type=template&id=5d0e3af8"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__